/* eslint-disable no-relative-import-paths/no-relative-import-paths */
import __ from "src/utils/Translations";
import orderCodeStatus from "../constants/orderCodeStatus";
import productCodeStatus from "../constants/productCodeStatus";
import { tourismOrderTypes } from "../constants/orderType";

const DAY_MILLISECONDS = 24 * 60 * 60 * 1000;

export const CodeItemStatusLabel = {
  CANCELED: "Anulowany",
  PENDING: "Przygotowujemy Twój kod",
  EXPIRED: "Przeterminowany",
  CAN_BE_USED: "Do wykorzystania",
  IS_USED: "Wykorzystany",
  WAITING_FOR_PAYMENT: "Oczekuje na płatność",
  TO_WITHDRAW: "Zgłoszono odstąpienie",
  WITHDRAWN: "Odstąpiono od zakupu",
  WITHDRAWN_ERROR: "Błąd zwrotu",
  TOURISM: "Turystyka",
};

export const CodeItemStatusCode = {
  AVAILABLE: "available",
  USED: "used",
  EXPIRED: "expired",
  CANCELED: "canceled",
  WAITING: "waiting",
  WAITING_FOR_PAYMENT: "waiting_for_payment",
  TO_WITHDRAW: "to_withdraw",
  WITHDRAWING: "withdrawing",
  WITHDRAWN: "withdrawn",
  WITHDRAWN_ERROR: "withdrawn_error",
  TOURISM: "tourism",
};

export const inactiveStatusCodes = [
  CodeItemStatusCode.CANCELED,
  CodeItemStatusCode.EXPIRED,
  CodeItemStatusCode.USED,
  CodeItemStatusCode.TO_WITHDRAW,
  CodeItemStatusCode.WITHDRAWING,
  CodeItemStatusCode.WITHDRAWN,
  CodeItemStatusCode.WITHDRAWN_ERROR,
];

const getCodeItemStatus = ({
  productCodeStatus: productStatus,
  orderStatus = "",
  orderType = "",
  productUserUsed,
  productExpirationDate,
}) => {
  if (tourismOrderTypes.includes(orderType)) {
    return {
      label: __(CodeItemStatusLabel.TOURISM),
      statusCode: CodeItemStatusCode.TOURISM,
      canShowCode: false,
    };
  }

  const isAvailable = !productUserUsed;
  const isExpired =
    productExpirationDate &&
    (Date.parse(productExpirationDate) || 0) + DAY_MILLISECONDS < Date.now();

  const {
    canceled,
    canceledError,
    claimFailed,
    reservationFailed,
    toWithdraw,
    withdrawn,
    withdrawing,
    withdrawnError,
    claimSuccess,
  } = productCodeStatus;

  const {
    canceled: orderCanceled,
    canceledError: orderCanceledError,
    canceledMissingPayment: orderCanceledMissingPayment,
    toCancel: orderToCancel,
    rollBackError: orderRollbackError,
    rollBack: orderRollback,
    rolledBack: orderRolledBack,
    toManuallyCancel: orderToManuallyCancel,
    manuallyCancelError: orderManuallyCancelError,
    claimSuccess: orderClaimSuccess,
    partiallyCancelled: orderPartiallyCancelled,
    partiallyWithdrawn: orderPartiallyWithdrawn,
    partiallyWithdrawnAndCancelled: orderPartiallyWithdrawnAndCancelled,
    waitingForPayment,
  } = orderCodeStatus;

  if (
    [canceled, canceledError, reservationFailed, claimFailed].includes(
      productStatus
    ) ||
    [
      orderCanceled,
      orderCanceledError,
      orderCanceledMissingPayment,
      orderToCancel,
      orderRollbackError,
      orderRollback,
      orderRolledBack,
      orderToManuallyCancel,
      orderManuallyCancelError,
    ].includes(orderStatus)
  ) {
    return {
      label: __(CodeItemStatusLabel.CANCELED),
      statusCode: CodeItemStatusCode.CANCELED,
      canShowCode: false,
    };
  }

  if (isExpired) {
    return {
      label: isAvailable
        ? __(CodeItemStatusLabel.EXPIRED)
        : __(CodeItemStatusLabel.IS_USED),
      statusCode: isAvailable
        ? CodeItemStatusCode.EXPIRED
        : CodeItemStatusCode.USED,
      canShowCode: true,
    };
  }

  if (productStatus === toWithdraw) {
    return {
      label: __(CodeItemStatusLabel.TO_WITHDRAW),
      statusCode: CodeItemStatusCode.TO_WITHDRAW,
      canShowCode: true,
    };
  }

  if (productStatus === withdrawn || productStatus === withdrawing) {
    return {
      label: __(CodeItemStatusLabel.WITHDRAWN),
      statusCode: CodeItemStatusCode.WITHDRAWN,
      canShowCode: false,
    };
  }

  if (productStatus === withdrawnError) {
    return {
      label: __(CodeItemStatusLabel.WITHDRAWN_ERROR),
      statusCode: CodeItemStatusCode.WITHDRAWN_ERROR,
      canShowCode: false,
    };
  }

  if (
    productStatus === claimSuccess &&
    [
      orderClaimSuccess,
      orderPartiallyCancelled,
      orderPartiallyWithdrawn,
      orderPartiallyWithdrawnAndCancelled,
    ].includes(orderStatus)
  ) {
    const statusCode = isAvailable
      ? CodeItemStatusCode.AVAILABLE
      : CodeItemStatusCode.USED;

    return {
      label: isAvailable
        ? __(CodeItemStatusLabel.CAN_BE_USED)
        : __(CodeItemStatusLabel.IS_USED),
      statusCode,
      canShowCode: isAvailable || statusCode === CodeItemStatusCode.USED,
    };
  }

  if (orderStatus === waitingForPayment) {
    return {
      label: __(CodeItemStatusLabel.WAITING_FOR_PAYMENT),
      statusCode: CodeItemStatusCode.WAITING_FOR_PAYMENT,
      canShowCode: false,
    };
  }

  return {
    label: __(CodeItemStatusLabel.PENDING),
    statusCode: CodeItemStatusCode.WAITING,
    canShowCode: false,
  };
};

export const getOrderItemStatusFilterOptions = () => {
  const labels = [
    CodeItemStatusLabel.CANCELED,
    CodeItemStatusLabel.EXPIRED,
    CodeItemStatusLabel.IS_USED,
    CodeItemStatusLabel.CAN_BE_USED,
    CodeItemStatusLabel.WAITING_FOR_PAYMENT,
    CodeItemStatusLabel.TO_WITHDRAW,
    CodeItemStatusLabel.WITHDRAWN,
    CodeItemStatusLabel.WITHDRAWN_ERROR,
    CodeItemStatusLabel.PENDING,
    CodeItemStatusLabel.TOURISM,
  ].map((label) => __(label));

  return [...new Set(labels)].map((label) => ({
    value: label,
    label,
  }));
};

export default getCodeItemStatus;
